// extracted by mini-css-extract-plugin
export var chevron = "_qr-1";
export var clickable = "_qr-0";
export var ruleRow = "_qr-2";